/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Vchip_SexualInputs */



/**
* | output |
* | --- |
* | "Sexual Situations" |
*
* @param {Subtitle_Export_Vchip_SexualInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_vchip_sexual = /** @type {((inputs?: Subtitle_Export_Vchip_SexualInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Vchip_SexualInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Situations sexuelles")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sexuelle Situationen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Situazioni sessuali")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сексуальные ситуации")
	if (locale === "es") return /** @type {LocalizedString} */ ("Situaciones sexuales")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("性爱场景")
	if (locale === "ja") return /** @type {LocalizedString} */ ("性的状況")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यौन स्थितियाँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Situações Sexuais")
	return /** @type {LocalizedString} */ ("Sexual Situations")
});